import { TOPIC } from "../../constants/topicConstants";
import { publish } from "../../utils/broadcast";
import { getEncKeyHeader } from "../../utils/customerToken";

const BaseClient = () => {

    const notifyGlobalError = (status) => {
        publish(TOPIC.API.GLOBAL_ERROR, {
            message: "We couldn't complete your request. Please try again.",
            status,
        });
    };

    const extractErrorMessage = (payload, fallback = "Request failed") => {
        const findMessage = (value) => {
            if (typeof value === "string" && value.trim()) return value.trim();

            if (Array.isArray(value)) {
                for (const item of value) {
                    const nested = findMessage(item);
                    if (nested) return nested;
                }
                return null;
            }

            if (value && typeof value === "object") {
                if (typeof value.message === "string" && value.message.trim()) return value.message.trim();
                if (typeof value.Message === "string" && value.Message.trim()) return value.Message.trim();
                if (typeof value.error === "string" && value.error.trim()) return value.error.trim();
                if (typeof value.Error === "string" && value.Error.trim()) return value.Error.trim();

                for (const nestedValue of Object.values(value)) {
                    const nested = findMessage(nestedValue);
                    if (nested) return nested;
                }
            }

            return null;
        };

        return findMessage(payload) || fallback;
    };

    const apiFetch = async (endpoint, options = {}, isAuthenticated, mapResponse = null, mapError = null) => {
        try {
            const fetchOptions = {
                ...options,
                headers: {
                    'Content-Type': 'application/json',
                    ...(options.headers || {}),
                },
            };

            if (options.body && typeof options.body !== 'string') {
                fetchOptions.body = JSON.stringify(options.body);
            }

            if(isAuthenticated){
                fetchOptions.headers = {
                    ...fetchOptions.headers,
                    GlympseApiKey: 'wuUthAkJaE283Ev8H8FOwC4VNda46nvF',
                    GoogleCaptchaAuthentication: 'tgAeRolDZQBxjZqrKKyYneldHExPUjDt',
                    WeatherAPIAuthentication: '9F1E8E334CEE9C9D8C35B4647159A',
                    ProductAPIAuthentication: 'B6RCJ82fBusTXXTeBixrNIwjrJzeBIVT',
                    YextAPIAuthentication: 'F9C224A59996FC3B22F55FA5786E4',
                    Bearer: '3rvf5hsk2uzxnkiwffaeg7t9ez31axxa',
                }
            }

            const encKey = isAuthenticated ? getEncKeyHeader() : null;
            if(encKey){
                fetchOptions.headers = {
                    ...fetchOptions.headers,
                    EncKey: encKey
                }
            }

            const res = await fetch(`${endpoint}`, fetchOptions);

            const contentType = res.headers.get('content-type');
            let data;
            if (contentType && contentType.includes('application/json')) {
                data = await res.json();
            } else {
                data = await res.text();
            }

            if (!res.ok) {
                const errorMessage = extractErrorMessage(data, res.statusText || "Bad Request");
                notifyGlobalError(res.status);
                return {
                    error: errorMessage,
                    status: res.status,
                    data,
                };
            }

            const resp = { data, status: res.status };
            return mapResponse != null? mapResponse(resp, options):resp;
        } catch (err) {
            const isCancelled = err?.name === 'AbortError';
            if (!isCancelled) {
                notifyGlobalError();
            }
            const error = {
                error: err.message || 'Network error',
            };
            return mapError != null?mapError(error):error;
        }
    }

    const get = async (endpoint, options = {}, isAuthenticated, mapResponse = null, mapError = null) => apiFetch(endpoint, { ...options, method: 'GET' }, isAuthenticated, mapResponse, mapError);

    const post = async (endpoint, body, options = {}, isAuthenticated, mapResponse = null, mapError = null) => apiFetch(endpoint, { ...options, method: 'POST', body }, isAuthenticated, mapResponse, mapError);

    const put = async (endpoint, body, options = {}, isAuthenticated, mapResponse = null, mapError = null) => apiFetch(endpoint, { ...options, method: 'PUT', body }, isAuthenticated, mapResponse, mapError);

    const formatError = (response, msg = "") => {
        return {
            errorMsg: msg !== ""?msg:response.data,
            errorCode: response.statusText,
            errorStatus: response.status
        }
    }

    return { apiFetch, get, post, put, formatError };
}

export default BaseClient;